import React from "react";
import {View, Stack, Heading, Text, Box} from "@unibuddy/patron";
import styled from "styled-components";

import {ConversationErrorLogo} from "../../../../components/ConversationErrorLogo";

type AssistantErrorProps = {
    widgetUrl?: string;
};

const StyledLink = styled.a`
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
    color: ${({theme}) => theme.colors.blue600};
`;

export function AssistantError({widgetUrl}: Readonly<AssistantErrorProps>) {
    return (
        <View height="100vh" justifyContent="center" bgColor="grey50">
            <View>
                <Stack space="medium" align="center">
                    <ConversationErrorLogo />
                    <Heading size="small" level="2">
                        {"We'll be back soon!"}
                    </Heading>
                    <Box w="100%" display="flex" justifyContent="center">
                        <Box marginX={["small", "xlarge"]} paddingX="small-medium">
                            {widgetUrl ? (
                                <Text size="small" color="grey600" align="center">
                                    {
                                        "We’ve encountered an unexpected issue. Please try again later, or "
                                    }
                                    <StyledLink href={widgetUrl}>
                                        chat to our ambassadors whilst you wait.
                                    </StyledLink>
                                </Text>
                            ) : (
                                <Text size="small" color="grey600" align="center">
                                    {
                                        "We’ve encountered an unexpected issue. Please try again later."
                                    }
                                </Text>
                            )}
                        </Box>
                    </Box>
                </Stack>
            </View>
        </View>
    );
}
